import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {I18nModule, UrlModule} from '@spartacus/core';
import {UserMenuComponent} from './user-menu.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgDesignSystemModule} from 'ng-design-system';
import {RouterModule} from '@angular/router';
import {GenericLinkModule, PageSlotModule} from '@spartacus/storefront';
import {UserMenuLinksComponent} from './user-menu-links/user-menu-links.component';
import {UserInfoComponent} from './user-info/user-info.component';

@NgModule({
  declarations: [
    UserMenuComponent,
    UserMenuLinksComponent,
    UserInfoComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    I18nModule,
    UrlModule,
    RouterModule,
    NgDesignSystemModule,
    PageSlotModule,
    GenericLinkModule
  ],
  exports: [
    UserMenuComponent
  ]
})
export class UserMenuModule {
}
